import { Button, Input, Spin, Table } from "antd";
import { PlusCircleFilled, SearchOutlined } from "@ant-design/icons";
import "../../styles/superAdmin/addClient.css";
import { Avatar } from "antd";
import { useSelector, useDispatch } from "react-redux";
import {
  closeModal,
  makeEditModeTrue,
  makeEditModeFalse,
  makeViewModeFalse,
  makeAddModeFalse,
  makeViewModeTrue,
  makeExtendModeTrue,
  makeExtendAllModeTrue,
  makeCancelModeTrue,
  makeAuditModeTrue,
  makeImpersonateLoginModeTrue,
} from "../../redux/Admin/adminActions";
import ClientDetails from "../UI/superAdmin/clientDetails";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TableActionColumn from "../UI/superAdmin/tableActionColumn";
import BackButton from "../UI/superAdmin/BackButton";
import { useGetClientsStats } from "../../hooks/useGetClientsStats";
import { useGetClients } from "../../hooks/useGetClients";
import StatsWidgets from "./StatsWidgets";
import { debounce } from "lodash";
import { formatDateTime } from "../util/helpers";
import AuditTrailModal from "../UI/superAdmin/modals/auditModal";
import ConfirmLoginModal from "../UI/superAdmin/modals/confirmlogin";

export default function Clients() {
  const [itemIndex, setItemIndex] = useState(null);
  const [searchClient, setSearchClient] = useState("");
  const editMode = useSelector((state) => state.admin.editMode);
  const addMode = useSelector((state) => state.admin.addMode);
  const viewMode = useSelector((state) => state.admin.viewMode);
  const loginMode = useSelector((state) => state.admin.loginMode);

  const { data: clientStats } = useGetClientsStats();
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;

  const {
    data: clientsData,
    isLoading: clientsLoading,
    refetch: refetchClients,
  } = useGetClients(currentPage, searchClient);
  const clientList = clientsData?.data || [];
  const totalClients = parseInt(clientsData?.total) || 0;
  console.log(clientList, "is list");
  const [selectedClient, setSelectedClient] = useState(null);

  const clientData = clientList.map((client, index) => ({
    key: ((currentPage - 1) * pageSize + index + 1).toString(),
    name: client.name,
    phone: client.phone || "N/A",
    modules: client.subscribed_modules,
    users: `${client.total_employee}/${client.expected_users}` || "N/A",
    db_usage: client?.db_usage_formatted || "N/A",
    audit_trails_count: client?.audit_trails_usage_formatted || "N/A",
    last_login: client.last_login_details?.last_login || "N/A",
    id: client.client_id,
  }));
  console.log({ clientList });

  // const selectedClient = clientData?.find(
  //   (client) => Number(client.key) === Number(itemIndex),
  // );

  const singleModuleMode = useSelector(
    (state) => state.admin.extendMode.perModule,
  );
  const allModuleMode = useSelector(
    (state) => state.admin.extendMode.allModule,
  );

  const columns = [
    { title: "#", dataIndex: "key", key: "key" },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => renderNeededComponent("name", record),
    },
    { title: "Phone Number", dataIndex: "phone", key: "phone" },
    { title: "Subscribed Modules", dataIndex: "modules", key: "modules" },
    { title: "Total Users", dataIndex: "users", key: "users" },
    { title: "Database Usage", dataIndex: "db_usage", key: "db_usage" },
    {
      title: "Audit Trails",
      dataIndex: "audit_trails_count",
      key: "audit_trails_count",
    },
    {
      title: "Last Login",
      dataIndex: "last_login",
      key: "last_login",
      render: (text, record) => formatDateTime(record.last_login),
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => renderNeededComponent("action", record),
    },
  ];

  const renderNeededComponent = (columnName, data) => {
    switch (columnName) {
      case "name":
        return renderNameColumn(data);
      case "action":
        return renderActionColumn(data);
      default:
        return data;
    }
  };

  const generateRandomShade = (baseColor) => {
    const hex = baseColor.replace(/[^0-9A-F]/gi, "");
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);

    const factor = 0.5 + Math.random() * 0.3;

    const newR = Math.floor(r * factor);
    const newG = Math.floor(g * factor);
    const newB = Math.floor(b * factor);

    return `#${newR.toString(16).padStart(2, "0")}${newG
      .toString(16)
      .padStart(2, "0")}${newB.toString(16).padStart(2, "0")}`;
  };

  const nameColorGenerator = (name) => {
    if (["A", "B", "C", "D", "E"].includes(name)) {
      return generateRandomShade("#00A85461");
    } else if (["F", "G", "H", "I", "J"].includes(name)) {
      return generateRandomShade("#CA38384A");
    } else if (["K", "L", "M", "N", "O"].includes(name)) {
      return generateRandomShade("#F3DC8180");
    } else if (["P", "Q", "R", "S", "T"].includes(name)) {
      return generateRandomShade("#CB66D373");
    } else if (["U", "V", "W", "X", "Y", "Z"].includes(name)) {
      return generateRandomShade("#3838CA73");
    }
    return "#666666";
  };

  const renderNameColumn = (record) => (
    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
      <Avatar
        style={{
          backgroundColor: nameColorGenerator(record.name[0]) || "#f0f0f0",
        }}
      >
        {record.name[0]}
      </Avatar>
      <div>
        <div style={{ fontWeight: "500" }}>{record.name}</div>
        <div style={{ fontSize: "12px", color: "#666" }}>{record.email}</div>
      </div>
    </div>
  );

  useEffect(() => {
    dispatch(closeModal());
  }, []);

  const handleViewDetailsClose = () => {
    setItemIndex(null);
    dispatch(closeModal(0));
    dispatch(makeEditModeFalse());
    dispatch(makeAddModeFalse());
    dispatch(makeViewModeFalse());
  };

  const handleViewDetails = (index) => {
    dispatch(makeEditModeFalse());
    dispatch(makeAddModeFalse());
    dispatch(makeViewModeTrue());
    setItemIndex(index);
    dispatch(closeModal(index));
  };

  const handleEditBtnClick = (index) => {
    setItemIndex(index);
    dispatch(makeEditModeTrue());
    dispatch(makeViewModeTrue());
    dispatch(closeModal(index));
  };

  const handleAuditClick = (record) => {
    // e.stopPropagation();
    setSelectedClient(record);
    dispatch(makeAuditModeTrue());
    dispatch(makeViewModeFalse());
  };

  const handleExtendSubscriptionClick = (index) => {
    dispatch(makeExtendModeTrue(index));
    dispatch(makeExtendAllModeTrue(index));
    dispatch(closeModal(index));
  };

  const handleImpersonateMode = (record) => {
    setSelectedClient(record);
    dispatch(makeImpersonateLoginModeTrue());
    dispatch(makeViewModeFalse());
  };

  const handleCancelSubscriptionClick = (index) => {
    dispatch(makeCancelModeTrue(index));
    dispatch(closeModal(index));
  };

  useEffect(() => {
    console.log("-----------> effect logs <--------------");
    console.log("All module mode", allModuleMode);
    console.log("single module mode", singleModuleMode);
    console.log("----------> End <--------------");
  }, [allModuleMode, singleModuleMode]);

  const navigate = useNavigate();
  const handleAddNewClientClick = () => {
    handleViewDetailsClose();
    navigate("/super_admin/add-client");
  };

  const dispatch = useDispatch();
  const isModalOpen = useSelector((state) => state.admin.modalOpen);

  const debouncedSearch = useCallback(
    debounce((value) => {
      setSearchClient(value);
      setCurrentPage(1);
    }, 500),
    [],
  );

  console.log(selectedClient, "client");

  const renderActionColumn = (record) => {
    console.log({ record });
    return (
      <TableActionColumn
        record={record}
        // handleModalOpen={handleModalOpen}
        clientId={record.id}
        handleViewDetails={handleViewDetails}
        handleEditBtnClick={handleEditBtnClick}
        handleExtendSubscriptionClick={handleExtendSubscriptionClick}
        handleImpersonateMode={() => handleImpersonateMode(record)}
        handleCancelSubscriptionClick={handleCancelSubscriptionClick}
        handleAuditClick={() => handleAuditClick(record)}
        isModalOpen={isModalOpen}
        refetchClients={refetchClients}
      />
    );
  };

  // ensures table is visible on initial render
  useEffect(() => {
    dispatch(makeViewModeFalse());
  }, [dispatch]);

  console.log({ clientData });

  return (
    <section className="w-100 py-2" id="negative-margin">
      <div className="w-100 row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 g-4 justify-content-lg-start justify-content-center align-items-center">
        <StatsWidgets clientStats={clientStats} />
        <div className="add_newBtn ms-lg-5">
          <Button
            size="large"
            className="add-client-button d-flex align-items-center justify-content-center"
            onClick={handleAddNewClientClick}
            icon={<PlusCircleFilled className="me-2" />}
          >
            Add New Client
          </Button>
        </div>
      </div>

      <div className="client-table-section mt-4">
        <>
          <div className="d-flex justify-content-between align-items-center mb-3 client-table-container">
            <h2 className="client-list-title">Client List</h2>
            <Input
              placeholder="Search Client"
              size="large"
              suffix={<SearchOutlined style={{ color: "#a4a4a4" }} />}
              className="client-search-input"
              onChange={(e) => debouncedSearch(e.target.value)}
            />
          </div>

          {clientsLoading ? (
            <div className="d-flex justify-content-center align-items-center py-5">
              <Spin size="large" style={{ color: "#4f46e5" }} />
            </div>
          ) : (
            <div className="client-table-container">
              <Table
                columns={columns}
                dataSource={clientData}
                className="client-table"
                pagination={{
                  current: currentPage,
                  pageSize: pageSize,
                  total: totalClients,
                  onChange: (page) => setCurrentPage(page),
                  showSizeChanger: false,
                }}
              />
            </div>
          )}
        </>

        {viewMode && itemIndex !== null && (
          <div>
            <BackButton backFn={handleViewDetailsClose} />
            <ClientDetails
              companyDetail={clientData[itemIndex - 1]}
              isEdit={editMode}
              addNewDetails={addMode}
            />
          </div>
        )}

        <AuditTrailModal selectedClient={selectedClient} />

        <ConfirmLoginModal open={loginMode} selectedClient={selectedClient} />
      </div>
    </section>
  );
}
